<template>
    <div>
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">

                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="isSaving"
                    v-if="
                        (!usuarioIntegracao || usuario.idusuario != null) && 
                        (
                            (!isUpdate && permissao.create) || 
                            (isUpdate && permissao.update)
                        )"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <div class="columns is-flex-wrap">
            <div
                class="column"
                :class="usuario.idusuario == null ? 'is-2' : 'is-3'"
            >
                <v-input
                    ref="codigoInput"
                    v-model="usuario.idusuarioerp"
                    placeholder="placeholder-preencha"
                    :maxlength="150"
                    title="codigo"
                    msg="msg-campo-obrigatorio"
                    :invalid="!usuario.idusuarioerp"
                    :disabled="cantEdit || usuarioIntegracao"
                    required
                />
            </div>
            <div
                class="column"
                :class="usuario.idusuario == null ? 'is-3' : 'is-4'"
            >
                <v-input
                    ref="nomeInput"
                    v-model="usuario.nome"
                    placeholder="placeholder-preencha"
                    :maxlength="150"
                    title="nome"
                    msg="msg-campo-obrigatorio"
                    :invalid="!usuario.nome"
                    :disabled="cantEdit || usuarioIntegracao"
                    required
                />
            </div>
            <div
                class="column"
                :class="usuario.idusuario == null ? 'is-3' : 'is-3'"
            >
                <v-input
                    ref="emailInput"
                    :hideInfo="hide.hideInfo"
                    :infoIsHidden="hide.infoIsHidden"
                    v-model="usuario.email"
                    placeholder="placeholder-preencha"
                    :maxlength="100"
                    title="email"
                    :msg="invalidEmailMsg"
                    :invalid="invalidEmail"
                    :onBlurFunction="validateUserEmail"
                    :disabled="cantEdit || usuarioIntegracao"
                    required
                />
            </div>
            <div class="column is-2">
                <label for="color">
                    {{ $t('selecione-uma-cor') }}
                    <b-icon 
                        icon="information" 
                        size="is-small" 
                        v-tippy 
                        title="Pincolor"
                    />
                </label>
                <color-picker
                    id="cor"
                    type="text"
                    :color="usuario.pincolor"
                    ref="cpInput"
                    @colorpicked="colorpicked"
                    :disabled="cantEdit || usuarioIntegracao"
                />
            </div>
            <!-- @85875 Permitir que o campo de login e senha possam ter 
                valores em minúsculo ou maiúsculo -->
            <div class="column is-2" v-if="usuario.idusuario == null">
                <v-input
                    ref="senhaInput"
                    v-model="usuario.senha"
                    placeholder="placeholder-preencha"
                    :maxlength="50"
                    title="senha"
                    :hideInfo="hide.hideInfo"
                    :infoIsHidden="hide.infoIsHidden"
                    :invalid="!usuario.senha && usuario.id == null"
                    :disabled="cantEdit"
                    :uppercase="false" 
                    required
                />
            </div>
            <div class="column is-4">
                <v-input
                    ref="loginInput"
                    :hideInfo="hide.hideInfo"
                    :infoIsHidden="hide.infoIsHidden"
                    :msg="invalidLoginMsg"
                    v-model="usuario.login"
                    placeholder="placeholder-preencha"
                    :maxlength="50"
                    title="login"
                    :invalid="invalidLogin"
                    :disabled="cantEdit || !(usuario.idusuario == null)"
                    :uppercase="false"
                    :onBlurFunction="validateLogin"
                    required
                />
            </div>
            <div class="column is-3">
                <verified-date-picker
                    :hideInfo="hide.hideInfo"
                    :infoIsHidden="hide.infoIsHidden"
                    v-model="date"
                    placeholder="selecione-uma-data"
                    title="data-nascimento-do-colaborador"
                    :subtractDateYears="80"
                    :yearsRange="[-50, 50]"
                    :inForm="true"
                    :disabled="cantEdit"
                />
            </div>
            <div class="column is-5">
                <v-input-tel
                    ref="celularInput"
                    :hideInfo="hide.hideInfo"
                    :infoIsHidden="hide.infoIsHidden"
                    v-model="usuario.celular"
                    title="celular"
                    :onBlurFunction="validateCelular"
                    :edit="inputCelularEdit"
                    :invalid="invalidCelular"
                    msg="msg-campo-invalido"
                    :disabled="cantEdit"
                />
            </div>
            <div class="column is-5">
                <v-input-tel
                    ref="telefoneInput"
                    :hideInfo="hide.hideInfo"
                    :infoIsHidden="hide.infoIsHidden"
                    v-model="usuario.telefone"
                    title="telefone"
                    :onBlurFunction="validateTelefone"
                    :edit="inputTelefoneEdit"
                    :invalid="invalidTelefone"
                    msg="msg-campo-invalido"
                    :disabled="cantEdit"
                />
            </div>
            <div class="column is-3">
                <vss-select
                    ref="diaSemanaSelect"
                    title="diascapturagps"
                    msg="msg-selecione-um-dia-da-semana"
                    :options="diasSemana"
                    :close-on-select="false"
                    multiple
                    ml-labels
                    v-model="diasSemanaSelected"
                    :disabled="cantEdit"
                    @onBlurFunction="sendIsChanged()"
                />
            </div>
            <div class="column is-2">
                <label>{{ $t('iniciocaptura') }}</label>
                <vue-timepicker
                    class="full-width"
                    close-on-complete
                    manual-input
                    v-model="iniciocaptura"
                    :disabled="cantEdit"
                />
            </div>
            <div class="column is-2">
                <label>{{ $t('terminocaptura') }}</label>
                <vue-timepicker
                    class="full-width"
                    close-on-complete
                    manual-input
                    v-model="terminocaptura"
                    :disabled="cantEdit"
                />
            </div>
            <div class="column is-2">
                <label>
                    {{ $t('pedido-email') }}
                </label>
                <br />
                <b-switch
                    v-model="optionPedidoEmail"
                    :title="
                        optionPedidoEmail
                            ? $t('ativado')
                            : $t('desativado')
                    "
                    :disabled="cantEdit || usuarioIntegracao"
                >
                    <span v-if="optionPedidoEmail">{{ $t('desativar') }}</span>
                    <span v-else>{{ $t('ativar') }}</span>
                </b-switch>
            </div>
            <div class="column is-7">
                <v-input
                    ref="extra1Input"
                    v-model="usuario.extra1"
                    placeholder="placeholder-preencha"
                    :maxlength="200"
                    title="extra1"
                    uppercase
                    :disabled="cantEdit || usuarioIntegracao"
                />
            </div>
            <div class="column is-3">
                <vss-select
                    ref="cidadeSelect"
                    label="nome"
                    v-model="cidade"
                    placeholder="selecione"
                    title="cidade"
                    :options="cidades"
                    :invalid="cidade == null"
                    msg="msg-campo-obrigatorio-para-localizacao"
                    searchable
                    :onBlurFunction="onCidade"
                    @search="loadCidade"
                    :disabled="cantEdit"
                    required
                />
            </div>
            <div class="column is-5">
                <v-input
                    ref="enderecoInput"
                    :hideInfo="hide.hideInfo"
                    :infoIsHidden="hide.infoIsHidden"
                    v-model="usuario.endereco"
                    placeholder="placeholder-preencha"
                    :maxlength="250"
                    title="endereco"
                    msg="msg-campo-obrigatorio-para-localizacao"
                    :invalid="!usuario.endereco"
                    uppercase
                    @input="debounceEndereco"
                    :disabled="cantEdit"
                    required
                />
            </div>
            <div class="column is-4">
                <v-input
                    ref="bairroInput"
                    v-model="usuario.bairro"
                    placeholder="placeholder-preencha"
                    :maxlength="250"
                    title="bairro"
                    msg="msg-campo-obrigatorio-para-localizacao"
                    :invalid="!usuario.bairro"
                    @input="debounceBairro"
                    uppercase
                    :disabled="cantEdit"
                    required
                />
            </div>
            <div class="column is-3" v-if="tipoVeiculos.length > 0">
                <vss-select
                    ref="tipoVeiculoSelect"
                    title="tipo-veiculo"
                    placeholder="selecione"
                    :options="tipoVeiculos"
                    v-model="tipoVeiculo"
                    :tagnewid="140621"
                    tooltipLabel="informacao-tipo-veiculo"
                    tooltipSize="is-large"
                    tooltipPosition="is-left"
                    :disabled="cantEdit"
                />
            </div>

            <div class="column is-3" v-if="false">
                <label>&nbsp;</label>
                <b-button
                    type="is-primary"
                    expanded
                    class="get-location mt-5"
                    @click="getLocation"
                    icon-pack="fas"
                    icon-left="map-marker-alt"
                    :disabled="cantEdit"
                >
                    {{ $t('pesquisar-localizacao') }}
                </b-button>
            </div>
            <div class="column is-6">
                <vss-select
                    ref="cargoSelect"
                    title="cargo"
                    :options="cargoSelect"
                    v-model="cargoSelected"
                    :search="loadCargos"
                    placeholder="placeholder-preencha"
                    tagnewid="220822"
                    :loading="loadingCargo"
                    @onBlurFunction="sendIsChanged()"
                    required
                />
            </div>
            <div class="column is-3">
                <b-button
                    type="is-primary"
                    expanded
                    class="get-location mt-5"
                    @click="getLocation"
                    icon-pack="fas"
                    icon-left="map-marker-alt"
                    :disabled="cantEdit"
                >
                    {{ $t('pesquisar-localizacao') }}
                </b-button>
            </div>
        </div>

        <div class="mt-4 mb-2 has-text-centered">
            <b-button
                outlined
                icon-left="eye-off-outline"
                type="is-danger"
                v-if="!hide.mapsIsHidden"
                @click="mapsIsHidden()"
            >
                {{ $t('esconder-localizacao') }}
            </b-button>
            <b-button
                outlined
                icon-left="eye-outline"
                type="is-success"
                v-if="hide.mapsIsHidden"
                @click="mapsIsHidden()"
            >
                {{ $t('mostrar-localizacao') }}
            </b-button>
            <b-image
                v-show="hide.mapsIsHidden"
                :src="require('@/assets/img/maps.png')"
                alt="Mapa"
                class="hide-location mt-2"
            />
        </div>
        <div class="location" v-show="!hide.mapsIsHidden">
            <GoogleMaps
                ref="gmap"
                :onClickFunction="getLocationValid"
                :geocoded="true"
                :startmarker="true"
                :zoom="15"
                :options="mapOptions"
                :clickMoveMarker="true"
            />
            <br />
        </div>
    </div>
</template>

<script>
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService';
import CategoriaConfigService from '@/services/CategoriaConfigService';
import CargoService from "@/services/promotor/cliente/CargoService";
import CidadeService from '@/services/CidadeService';
import ValoresKmService from '@/services/despesas/ValoresKmService';
import gerenciarUsuarioValidation from '@/services/validations/GerenciarUsuariosValidation';
import ColorPicker from '@/components/shared/form/ColorPicker';
import Message from '@/models/Message';
import GoogleMaps from '@/components/shared/maps/MapasGoogleMaps';
import { mapState } from 'vuex';

export default {
    components: {
        ColorPicker,
        GoogleMaps,
    },
    data() {
        return {
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('USUARIO'),
            optionPedidoEmail: false,
            service: new GerenciarUsuariosService(this.$http, this.$router),
            caregoriaService: new CategoriaConfigService(this.$http, this.$router),
            cargoService: new CargoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: new gerenciarUsuarioValidation(this.msgs),
            date: null,
            dateInvalid: false,
            iniciocaptura: { HH: '', mm: '' },
            terminocaptura: { HH: '', mm: '' },
            loadingCargo: false,
            cargoSelected: null,
            cargoSelect: [],
            invalidEmailMsg: "msg-campo-obrigatorio",
            invalidLoginMsg: "msg-campo-obrigatorio",
            usuario: {
                idusuario: null,
                idusuarioerp: null,
                nome: null,
                email: null,
                login: null,
                senha: null,
                pincolor: '#D0CFCF',
                extra1: null,
                diascapturagps: '',
                iniciocaptura: null,
                terminocaptura: null,
                latitude: null,
                longitude: null,
                idcidade: null,
                endereco: null,
                bairro: null,
                telefone: null,
                celular: null,
                datanascimento: null,
                pedidoemail: 0,
                idtipoveiculo: null,
                idusuariocargo: null,
            },
            invalidIcon: false,
            cidade: null,
            cidades: [],
            cidadeservice: new CidadeService(this.$http, this.$router),
            canSelectCidade: false,
            mapOptions: { gestureHandling: 'cooperative' },
            diasSemana: [
                { value: '1', label: 'domingo' },
                { value: '2', label: 'segunda' },
                { value: '3', label: 'terca' },
                { value: '4', label: 'quarta' },
                { value: '5', label: 'quinta' },
                { value: '6', label: 'sexta' },
                { value: '7', label: 'sabado' },
            ],
            diasSemanaSelected: [],
            invalidGetLocation: false,
            isUpdate: false,
            tipoVeiculos: [],
            tipoVeiculo: null,
            valoresKmService: new ValoresKmService(this.$http, this.$router),
            fields: [
                { key: 'label-tabela-usuario', width: null, sortable: false, sortFn: null },
                { key: 'descricao', width: null, sortable: false, sortFn: null },
                { key: 'valor', width: null, sortable: false, sortFn: null },
            ],
            isEmpty: true,
            parametrizacoes: [],
            debouncedOnSearchParam: null,
            queryFilter: '',
            queryFilterParam: '',
            isLoadingParams: false,
            categorias: [],
            categoria: { id: 0, label: 'todos' },
            inputCelularEdit: false,
            inputTelefoneEdit: false,
            invalidTelefone: false,
            invalidCelular: false,
            invalidEmail: false,
            invalidLogin: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            validateAddress: [
                'postal_code',
                'administrative_area_level_1',
                'administrative_area_level_2',
                'route',
            ],
            cidadesFull: [],
            debounceEndereco: null,
            debounceBairro: null,
            cantEdit: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.$route.params.id) this.isUpdate = true;

        let titulo = this.$route.params.id ? 'editar-usuario' : 'adicionar-usuario';
        this.permissao = this.hasPermissionAccess('admin', 'colaborador', 'usuario-gerenciar');
        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: titulo },
            });
        } else {
            if (this.isUpdate) {
                this.cantEdit = !this.permissao.update;

                this.carregarDados(this.$route.params.id);
                this.debouncedOnSearchParam = this.debounce(this.onSearchParam, 500);
                this.debounceEndereco = this.debounce(this.onEndereco, 500);
                this.debounceBairro = this.debounce(this.onBairro, 500);
                this.carregarCategorias();
                // @84599 - Chama o método para carregar os parâmetros do usuário quando a tela é iniciada
                this.carregarParamUsuario(
                    this.pagination.currentPage,
                    this.$route.params.id,
                    this.categoria.id,
                    this.queryFilterParam
                );
            } else {
                this.findAllTipoVeiculo();
                this.loadCargos();
            }
            this.loadCidadeFull(10000);
            setTimeout(() => {
                this.$emit("isChanged", false);
            }, 500);
            
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    watch: {
        optionPedidoEmail(v) {
            this.usuario.pedidoemail = v ? 1 : 0;
        },
        usuario :{
            deep: true,
            handler: function() {
                    if(!this.isLoading && !this.isSaving){
                        this.$emit("isChanged", true);
                    }else this.$emit("isChanged", false);
            }
        },
        iniciocaptura :{
            deep: true,
            handler: function() {
                    if(!this.isLoading && !this.isSaving){
                        this.$emit("isChanged", true);
                    }else this.$emit("isChanged", false);
            }
        },
        terminocaptura :{
            deep: true,
            handler: function() {
                    if(!this.isLoading && !this.isSaving){
                        this.$emit("isChanged", true);
                    }else this.$emit("isChanged", false);
            }
        },
        date :{
            deep: true,
            handler: function() {
                if(!this.isLoading && !this.isSaving){
                    this.$emit("isChanged", true);
                }else this.$emit("isChanged", false);
            }
        },
    },
    methods: {
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
        },
        onSearchParam(value) {
            this.queryFilterParam = value;
            this.carregarParamUsuario(
                this.pagination.currentPage,
                this.$route.params.id,
                this.categoria.id,
                this.queryFilterParam
            );
        },
        /**
         * @70830 - criado esses metodos com debounce
         * para quando o usuario digitar um endereço, bairro
         * ou trocar a cidade, seja atualizado a localização do mapa.
         */
        onCidade() {
            this.$refs.gmap.geocoder && this.getLocation();
            this.sendIsChanged();
        },
        sendIsChanged() {
            if (!this.isLoading&&!this.isSaving) this.$emit("isChanged", true);
        },
        onEndereco() {
            this.$refs.gmap.geocoder && this.getLocation();
        },
        onBairro() {
            this.$refs.gmap.geocoder && this.getLocation();
        },
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', { infoIsHidden: !this.hide.infoIsHidden });
        },
        mapsIsHidden() {
            this.$store.dispatch('mapsIsHidden', { mapsIsHidden: !this.hide.mapsIsHidden });
        },
        colorpicked(color) {
            this.usuario.pincolor = color;
        },
        loadCidade(value) {
            this.cidadeservice
                .findAll(0, 100, value ? value : '')
                .then(this.mapItemsCidade)
                .then((allcidades) => {
                    this.cidades = Object.assign(allcidades);
                    this.cidades.sort();
                }, 350);
        },
        /**
         * @70830 - criei esse metodo para retornar todas as cidades
         * para mim poder realizar o filtro da qual foi salva no banco.
         */
        loadCidadeFull(limit = 100, pesquisa = '') {
            this.cidadeservice
                .findAll(0, limit, pesquisa || '')
                .then(this.mapItemsCidade)
                .then((allcidades) => {
                    this.cidadesFull = Object.assign(allcidades);
                    this.cidadesFull.sort();
                });
        },
        loadCidadeById(id) {
            this.cidadeservice
                .find(id)
                .then((cidade) => {
                    if (cidade.content != null) {
                        let temp = {
                            id: cidade.content.id,
                            nome: cidade.content.descricao,
                        };
                        this.cidade = temp;
                    }
                }, 350)
                .catch((e) => {
                    console.error(e);
                    
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                });
        },
        mapItemsCidade(body) {
            return body.content.map((i) => {
                return {
                    id: i.idcidade,
                    nome: i.descricao,
                };
            });
        },
        getLocation() {
            if (this.cidade != null) this.usuario.idcidade = this.cidade.nome;
            if (this.usuario.idcidade && (this.usuario.endereco || this.usuario.bairro)) {
                this.invalidGetLocation = false;
                let address =
                    this.usuario.endereco + ', ' + this.usuario.bairro + ', ' + this.cidade.nome;
                let mapa = this.$refs.gmap;
                mapa.codeAddress(address, (results, status) => {
                    if (status == 'OK') {
                        let latlong = results[0].geometry.location;
                        this.usuario.latitude = latlong.lat();
                        this.usuario.longitude = latlong.lng();

                        (mapa.center.lat = this.usuario.latitude),
                            (mapa.center.lng = this.usuario.longitude);

                        mapa.loadSingleMarker();

                        this.usuario.latitude = mapa.center.lat;
                        this.usuario.longitude = mapa.center.lng;
                    } else {
                        if (status == 'REQUEST_DENIED') {
                            this.msgs.push(
                                new Message(
                                    'error',
                                    this.$t('msg-geocode-activate'),
                                    true,
                                    false
                                )
                            );
                        }
                        this.msgs.push(
                            new Message(
                                'error',
                                this.$t('msg-geocode-fail') + status,
                                true,
                                false
                            )
                        );
                    }
                });
            }
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .findById(id)
                .then((usuario) => {
                    this.usuario = usuario.content;
                    this.cargoSelected = usuario.content.usuariocargo && usuario.content.usuariocargo.id
                        ? { id: usuario.content.usuariocargo.idusuariocargo,
                            label: usuario.content.usuariocargo.descricao}
                        : null;
                    this.usuario.celular = !usuario.content.celular ? '' : usuario.content.celular;
                    this.usuario.email = !usuario.content.email ? '' : usuario.content.email;
                    this.usuario.telefone = !usuario.content.telefone
                        ? ''
                        : usuario.content.telefone;

                    if (!this.usuarioIntegracao) {
                        this.usuario.pincolor = '#' + (this.usuario.pincolor || 'D0CFCF');
                        this.optionPedidoEmail = this.usuario.pedidoemail == 1 ? true : false;
                    }
                    this.$refs.gmap.center.lat = +this.usuario.latitude;
                    this.$refs.gmap.center.lng = +this.usuario.longitude;
                    if (this.usuario.iniciocaptura != null) {
                        let tempIniciocaptura = this.usuario.iniciocaptura.split(':');
                        this.iniciocaptura = {
                            HH: tempIniciocaptura[0],
                            mm: tempIniciocaptura[1],
                        };
                    }
                    if (this.usuario.terminocaptura != null) {
                        let tempTerminocaptura = this.usuario.terminocaptura.split(':');
                        this.terminocaptura = {
                            HH: tempTerminocaptura[0],
                            mm: tempTerminocaptura[1],
                        };
                    }
                    if (this.usuario.idcidade != null) this.loadCidadeById(this.usuario.idcidade);
                    if (this.usuario.diascapturagps != null) {
                        let tempDiasSemana = this.usuario.diascapturagps.split(',');
                        Object.entries(tempDiasSemana).forEach(([key, value]) => {
                            this.diasSemanaSelected.push(
                                ...this.diasSemana.filter((v) => v.value == value)
                            );
                        });
                    }
                    if (this.usuario.datanascimento != null)
                        this.date = this.$moment(this.usuario.datanascimento).toDate();

                    this.findAllTipoVeiculo();
                    this.checkEditTel();
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false; 
                    this.validateTelefone();
                    this.validateCelular();
                    this.loadCargos();
                    this.loadCargos();
                    this.$emit("isChanged", false);
                });
        },
        findAllTipoVeiculo() {
            this.valoresKmService
                .findAllCombo('')
                .then(this.mapItemsTipoVeiculo)
                .then((res) => {
                    this.tipoVeiculos = res;
                    if (this.$route.params.id && this.usuario.idtipoveiculo != null) {
                        this.tipoVeiculo = this.tipoVeiculos.filter(
                            (f) => f.id == this.usuario.idtipoveiculo
                        )[0];
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        },
        mapItemsTipoVeiculo(body) {
            return body.content.map((m) => {
                return {
                    id: m.tipoVeiculo.idtipoveiculo,
                    label: m.tipoVeiculo.descricao,
                    cor: m.tipoVeiculo.cor,
                    icone: m.tipoVeiculo.icone.toLowerCase(),
                };
            });
        },
        save() {
            this.isLoading = true;
            this.usuario.idusuariocargo = this.cargoSelected ? this.cargoSelected.id : null;
            this.validateUserEmail();
            if (this.validation.validate(this.usuario, this.$refs, this.usuarioIntegracao)) {
                if (!this.invalidEmail && !this.invalidTelefone && !this.invalidCelular) {
                    this.invalidGetLocation = false;

                    let mapa = this.$refs.gmap;

                    this.usuario.latitude = mapa.center.lat;
                    this.usuario.longitude = mapa.center.lng;

                    if (this.cidade != null) this.usuario.idcidade = this.cidade.id;

                    this.usuario.pedidoemail = this.optionPedidoEmail ? 1 : 0;

                    this.usuario.datanascimento =
                        this.date != null ? this.$moment(this.date).format('YYYY-MM-DD') : null;

                    this.usuario.iniciocaptura =
                        this.iniciocaptura.HH != '' && this.iniciocaptura.mm != ''
                            ? this.iniciocaptura.HH + ':' + this.iniciocaptura.mm + ':00'
                            : null;

                    this.usuario.terminocaptura =
                        this.terminocaptura.HH != '' && this.terminocaptura.mm != ''
                            ? this.terminocaptura.HH + ':' + this.terminocaptura.mm + ':00'
                            : null;

                    this.usuario.diascapturagps = '';

                    if (this.diasSemanaSelected != null) {
                        this.usuario.diascapturagps = this.diasSemanaSelected
                            .sort((a, b) => a.value.localeCompare(b.value))
                            .map((e) => e.value)
                            .join(',');
                    }
                    
                    this.usuario.idtipoveiculo =
                        this.tipoVeiculo != null ? this.tipoVeiculo.id : null;

                    let usuarioTemp = Object.assign({}, this.usuario);
                    usuarioTemp = this.mapTosave(usuarioTemp);
                    usuarioTemp.iniciocaptura = this.usuario.iniciocaptura;
                    usuarioTemp.terminocaptura = this.usuario.terminocaptura;
                    usuarioTemp.email = this.usuario.email;
                    usuarioTemp.pincolor = this.usuario.pincolor.substring(1) || 'D0CFCF'; 
                    this.invalidIcon = false;
                    this.isSaving = true;
                    this.service
                        .save(usuarioTemp)
                        .then((value) => {
                            if (value.message == null) {
                                let msg = (this.isUpdate) ?
                                    'msg-edit-gerenciar-usuario' : 
                                    'msg-save-gerenciar-usuario'
                                this.$root.showMessage('success', msg, true, true, this.isUpdate?5:20);

                                if (this.$route.query.tela) {
                                    this.$root.confirm({
                                        message: this.$t('msg-necessita-ativar-usuario'),
                                        confirmText: 'voltar',
                                        cancelText: 'gerenciar-usuarios',
                                        onConfirm: (_) => this.$emit('promptChangeTab', true),
                                        onCancel: (_) => this.redirectToList(),
                                    });
                                } else if(!this.isUpdate) {
                                    this.redirectToList();
                                }
                            } else {
                                if (value.message && value.message == "msg-codigo-duplicado-n") {
                                    let msgErro = this.$t(value.message, { n: this.usuario.idusuarioerp });
                                    this.$root.showMessage('alert', msgErro, true, false);
                                } else if (value.message == 'msg-login-duplicado') {
                                    this.invalidLogin = true;
                                    this.invalidLoginMsg = "msg-login-duplicado";
                                    this.$root.showMessage('alert', value.message, true);
                                } else if (this.$t(value.message)) {
                                    this.$root.showMessage('alert', value.message, true);
                                } else {
                                    this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                                }
                            }
                            this.status = value.status;
                        })
                        .catch((e) => {
                            this.status = e.status;
                            if (e.body && e.body.message && this.$te(e.body.message)) {
                                let message = e.body.message;
                                let msgErro;
                                if (message == "msg-codigo-duplicado-n") {
                                    msgErro = this.$t(e.body.message, { n: this.usuario.idusuarioerp });
                                    this.msgs.push(new Message("alert", msgErro, true, false));
                                } else {
                                    msgErro = this.$t(message);
                                    this.msgs.push(new Message("alert", msgErro, true, false));
                                }
                            } else {
                                this.msgs.push(
                                    new Message("error", "msg-problema-realizar-acao", true)
                                );
                            }
                        })
                        .finally(() => {
                            this.isSaving = false;
                            this.isLoading = false;
                            this.$emit("isChanged", false);
                            if (this.$route.query.tela) {
                                if (
                                    this.$route.query.tela == 'cliente-vendedor' ||
                                    this.$route.query.tela == 'empresa-usuario'
                                ) {
                                    this.$root.confirm({
                                        message: this.$t('msg-necessita-ativar-usuario'),
                                        confirmText: 'gerenciar-usuarios',
                                        cancelText: 'voltar',
                                        onConfirm: (_) => this.redirectToList(),
                                        onCancel: (_) => this.$emit('promptChangeTab', true),
                                    });
                                } else {
                                    this.$emit('promptChangeTab', true);
                                }
                            } else if(this.status == 200){
                                this.redirectToList();
                            }
                        });
                } else {
                    let msg = '';
                    if (this.invalidCelular) {
                        msg = 'msg-celular-invalido';
                    } else if (this.invalidTelefone) {
                        msg = 'msg-telefone-invalido';
                    } else if (this.invalidEmail) {
                        msg = 'msg-email-invalido';
                    }
                    this.$root.showMessage('error', msg, true);

                    this.isSaving = false;
                    this.isLoading = false;
                }
            } else {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios');

                this.isLoading = false;
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: 'usuario-gerenciar-list',
                });
            }, 1000);
        },
        redirectToEdit(id) {
            setTimeout(() => {
                this.$router.push({
                    name: 'usuario-gerenciar-edit',
                    params: { id: id },
                });
            }, 1000);
        },

        checkEditTel() {
            this.inputCelularEdit = !this.isNull(this.usuario.celular);
            this.inputTelefoneEdit = !this.isNull(this.usuario.telefone);
        },
        validateTelefone() {
            if (this.isNull(this.usuario.telefone)) {
                this.invalidTelefone = false;
            } else if (!this.validatePhone(this.usuario.telefone)) {
                this.invalidTelefone = true;
                this.$refs.telefoneInput.focusedOut = true;
            } else {
                this.invalidTelefone = false;
            }
        },
        validateCelular() {
            if (this.isNull(this.usuario.celular)) {
                this.invalidCelular = false;
            } else if (!this.validatePhone(this.usuario.celular)) {
                this.invalidCelular = true;
                this.$refs.celularInput.focusedOut = true;
            } else {
                this.invalidCelular = false;
            }
        },
        validateUserEmail() {
            if(this.isNull(this.usuario.email)) {
                this.invalidEmail = true;
                this.invalidEmailMsg = "msg-campo-obrigatorio";
            }else if (
                !this.validateEmail(this.usuario.email)
            ) {
                this.invalidEmail = true;
                this.invalidEmailMsg = "msg-email-invalido";
            } else {
                this.invalidEmail = false;
            }
        },
        validateLogin() {
            if(this.isNull(this.usuario.login)) {
                this.invalidLogin = true;
                this.invalidLoginMsg = "msg-campo-obrigatorio";
            } else {
                this.invalidLogin = false;
            }
        },
        carregarParamUsuario(currentPage = 1, id, situacao = 0, ...params) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoadingParams = true;
            this.service
                .getParamsUsuario(currentPage - 1, this.pagination.perPage, id, situacao, params)
                .then((value) => {
                    this.pagination.totalRows = value.totalElements;
                    this.parametrizacoes = value.content;
                    this.parametrizacoes.forEach((e) => {
                        e.valor = this.jsonFormatter(e.tipo, e.valor);
                    });
                    this.isEmpty = this.parametrizacoes <= 0;
                })
                .catch((e) => {
                    this.isLoadingParams = false;
                    this.isEmpty = true;
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoadingParams = false;
                });
        },
        onCategoriaChanged(val) {
            this.categoria = val
                ? this.categorias.filter((v) => v.id == val.id)[0]
                : this.categorias[0];
            this.carregarParamUsuario(
                this.pagination.currentPage,
                this.$route.params.id,
                this.categoria.id,
                this.queryFilterParam
            );
        },
        carregarCategorias() {
            this.caregoriaService
                .findAllComboUser(this.$route.params.id, '')
                .then((value) => {
                    if (value.status === 200) {
                        if (value.content) {
                            if (value.content.length > 0) {
                                this.categorias.push({
                                    id: 0,
                                    label: 'todos',
                                });
                                value.content.map((e) => {
                                    this.categorias.push({
                                        id: e.idcategoriaconfig,
                                        label: e.nome,
                                    });
                                });
                            } else {
                                this.categorias = [];
                                this.categoria = {};
                            }
                        }
                    } else {
                        this.categorias = [];
                        this.categoria = {};
                        console.error(value.message);
                        this.msgs.push(new Message('error', 'msg-erro-load', true));
                    }
                })
                .catch((e) => {
                    this.categorias = [];
                    this.categoria = {};
                    console.error(e);
                });
        },
        loadCargos(search) {
            search = this.isNull(search) ? '.*' : this.removeToSearch(search);
            this.loadingCargo = true;
            this.cargoService
                .findAllCombo(50, search)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idcargo,
                            label: m.descricao,
                        };
                    });
                })
                .then(allcargos => {
                    this.cargoSelect = allcargos;
                    this.cargoSelect.sort();
                }, 350)
                .catch((e) => {
                    console.error(e);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    if (this.isUpdate) {
                        if(Array.isArray(this.cargoSelect) && this.cargoSelect.length > 0) {
                            let temp = this.cargoSelect.find(f => f.id == this.usuario.usuariocargo.id);
                            if(temp == undefined) this.cargoSelect.push(this.cargoSelected);
                        }else{
                            this.cargoSelect.push(this.cargoSelected);
                        }
                    } else {
                        if(Array.isArray(this.cargoSelect) && this.cargoSelect.length > 0) {
                            let temp = this.cargoSelect.find(f => f.id == 1);
                            if(temp != undefined) this.cargoSelected = temp;
                        }
                    }
                    this.loadingCargo = false
                });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarParamUsuario(
                value.currentPage,
                this.$route.params.id,
                this.categoria.id,
                this.queryFilterParam
            );
        },
        jsonFormatter(tipo, valor) {
            if (tipo) {
                let json = JSON.parse(tipo);
                if (json.type === 'select') {
                    return json.options.filter((e) => {
                        if (e.value === valor) {
                            return e.name;
                        }
                    })[0].name;
                } else {
                    return valor;
                }
            } else {
                return valor;
            }
        },
        /**
         * @70830 - essa função é executada a cada vez que é clicado no mapa.
         *
         * A variável validateAddress, contém todas as informações que são necessárias,
         * para um determinado endereço seja válido. Foi feito uma verificação de como o Google Maps
         * retorna o endereço.
         *
         * ['postal_code', 'administrative_area_level_1', 'administrative_area_level_2', 'route'],
         *
         * postal_colode -> Código Postal
         * administrative_area_level_1 -> Estado,
         * administrative_area_level_2 -> Cidade
         * route -> Rua, Avenida etc.
         */
        getLocationValid(lat, lng) {
            let isValid = false;

            this.$refs.gmap.codeAddress(`${lat}, ${lng}`, (result, status) => {
                if (status == 'OK') {
                    let validations = [];
                    let resultAddress = result[0].address_components;

                    resultAddress.forEach((address) => {
                        address.types.forEach((type) => {
                            if (this.validateAddress.includes(type)) {
                                validations.push(type);
                            }
                        });
                    });

                    isValid = validations.length === this.validateAddress.length;

                    if (isValid) {
                        let addressComplete = resultAddress;
                        /**
                         * @70830 - Caso o endereço contenha todas as informações, número
                         * da rua, rua, bairro, cidade, estado e código postal.
                         */
                        if (addressComplete.length == 7) {
                            let [
                                street_number,
                                route,
                                district,
                                city,
                                state,
                                _,
                                postal_code,
                            ] = addressComplete;

                            this.usuario.endereco = `${route.long_name}, ${
                                street_number.long_name
                            }, ${postal_code.long_name}`;
                            this.usuario.bairro = district.long_name;

                            let cidadeSelect = this.removeAcentos(
                                `${state.short_name} - ${city.long_name}`
                            ).toLowerCase();

                            this.cidade = this.cidadesFull.find((elemento) => {
                                return elemento.nome.toLowerCase() == cidadeSelect;
                            });
                            /**
                             * @70830 - caso o retorno não possua o número da rua.
                             */
                        } else if (addressComplete.length == 6) {
                            var [route, district, city, state, _, postal_code] = addressComplete;

                            let cidadeSelect = this.removeAcentos(
                                `${state.short_name} - ${city.long_name}`
                            ).toLowerCase();

                            this.usuario.endereco = `${route.long_name}, ${postal_code.long_name}`;
                            this.usuario.bairro = district.long_name;
                            this.cidade = this.cidadesFull.find((elemento) => {
                                return elemento.nome.toLowerCase() == cidadeSelect;
                            });
                            /**
                             * @70830 - caso o retorno não possua o número da rua nem o bairro.
                             */
                        } else {
                            var [route, city, state, _, postal_code] = addressComplete;

                            let cidadeSelect = this.removeAcentos(
                                `${state.short_name} - ${city.long_name}`
                            ).toLowerCase();

                            this.usuario.endereco = `${route.long_name}, ${postal_code.long_name}`;
                            this.usuario.bairro = '';
                            this.cidade = this.cidadesFull.find((elemento) => {
                                return elemento.nome.toLowerCase() == cidadeSelect;
                            });
                        }
                    } else {
                        this.usuario.endereco = '';
                        this.usuario.bairro = '';
                        this.cidade = null;
                        this.$refs.enderecoInput.focusedOut = false;
                        this.$refs.bairroInput.focusedOut = false;
                        this.$refs.cidadeSelect.focusedOut = false;
                    }
                } else {
                    this.msgs.push(
                        new Message('error', this.$t('msg-geocode-activate'), true, false)
                    );
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    input {
        text-transform: none;
    }

    .page {
        position: relative;
        padding-left: 0;
        display: block;
        clear: both;

        .replicapda-select {
            width: 50%;
            div {
                height: 40px;
            }
        }

        .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 50%;
                padding-right: 10px;
            }
        }

        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0px !important;
            }

            .replicapda-select {
                width: 100%;
            }

            .descricao-tabela-parametrizacao {
                text-align: left;
                width: auto !important;
            }
        }

        @media screen and (max-width: 768px) {
            .b-table
                .table-wrapper.has-mobile-cards
                tr:not(.detail):not(.is-empty):not(.table-footer)
                td:before {
                word-break: initial;
            }
        }
    }
    .column {
        padding-top: 1px;
    }
    .without-background {
        background: none !important;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
    .box {
        background-color: #fdfdfd;
    }
    .column {
        height: 100% !important;
    }
    .get-location {
        height: 36px;
    }
    .hide-location {
        border: solid 2px #f9f9f9;
        border-radius: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    }
    .location {
        width: 100%;
        height: auto;
        flex: 1 1 auto;
        // margin-top: 20px;
        position: relative;
        min-height: 350px;
        height: auto;
        margin-bottom: 20px;
        display: block;
        clear: both;
        border: solid 2px #f9f9f9;
        border-radius: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    }
}
</style>
